import { render } from "./TipShareForm.vue?vue&type=template&id=02d6e404"
import script from "./TipShareForm.vue?vue&type=script&lang=js"
export * from "./TipShareForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__